import { Btn } from "../../../../../AbstractElements";
import CommonModal from "../../Common/CommonModal";
import WebDesign from "./WebDesign"
import UXDesigner from "./UXDesigner"
import { CommonFullScreenDataType } from "../../../../../Type/UiKits";

const CommonFullScreenData = ({color,onClick,title,fullscreen,isOpen,toggle}:CommonFullScreenDataType) => {
  return (
    <>
      <Btn outline color={color} type="button" onClick={onClick}>{title}</Btn>
      <CommonModal fullscreen={fullscreen} modalTitleClassName="fs-5" fullTitle={title} isOpen={isOpen} toggle={toggle} modalBodyClassName="dark-modal">
        <WebDesign />
        <UXDesigner />
      </CommonModal>
    </>
  );
};

export default CommonFullScreenData;
